<template>
    <div class="col-span-12 md:col-span-4 box">
        <div class="flex border-b-1 items-center border-custom-member">
            <div class="p-2 bg-primary-1 text-white">
                <BookOpenIcon v-if="newsSection.text == 'เกี่ยวกับโครงการ'" />
                <SettingsIcon v-if="newsSection.text == 'เกี่ยวกับระบบ'" />
                <FileTextIcon v-if="newsSection.text == 'ข่าวสาร/ประกาศอื่น'" />
            </div>
            <div class="p-2">
                <h4 class="text-custom-member">{{newsSection.text}}</h4>
            </div>
        </div>
        <div class="p-5 text-gray-600">
            <div class="h-[260px] overflow-y-auto p-0" @scroll="onScroll(newsSection.text,$event)">
                <news-item v-for="(item, key) in dataList" :key="key" :data="item"></news-item>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent, onMounted, ref } from 'vue'
import NewsItem from "./NewsItem.vue"
import axios from "axios"
export default defineComponent({
    props:{
        newsSection: Object,
    },
    components:{
        NewsItem
    },
    setup(props){
        const dataList = ref([])
        const recordsTotal = ref(0)
        const currentPage = ref(1)
        const fetchNews = (category) =>{
            const config = {
                url: `${process.env.VUE_APP_BASE_API}news/getNews/`,
                method: "POST",
                data:
                {
                    CATEGORY: category,
                    start: currentPage.value,
                    length: 10,
                    sorters:[
                        {
                            field: "createdAt",
                            dir: "desc"
                        }
                    ]
                },
            };
            axios(config)
            .then((response) => {
                for(let item of response.data.data){
                    dataList.value.push(item)
                }
                recordsTotal.value = response.data.recordsTotal
            })
            .catch((error)=>{
                console.log(error);
            })
        }
        const onScroll = (newsType,{ target: { scrollTop, clientHeight, scrollHeight }}) => {
            if (scrollTop + clientHeight >= scrollHeight && !(dataList.value.length == recordsTotal.value)) {
                currentPage.value += 1
                fetchNews(newsType)
            }
        }
        onMounted(()=>{
            fetchNews(props.newsSection.text)
        })
        return {
            dataList,
            onScroll
        }
    }
})
</script>

<style>

</style>